module.exports = __webpack_public_path__ + "static/media/play-stone-boss-3.51fddef1.png";